import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { UserMessage } from '../models/interfaces/user-message.interface';
import { RoomMessageDto } from '../models/dto/room-message.dto';
import { ConfirmRoomMessageVisualizedDto } from '../models/dto/confirm-room-message-visualized.dto';
import { ConfirmUserMessageVisualizedDto } from '../models/dto/confirm-user-message-visualized.dto';
import { ConfirmUserMessageReceivedDto } from '../models/dto/confirm-user-message-received.dto';
import { ConfirmUserMessageRemovedDto } from '../models/dto/confirm-user-message-removed.dto';
import { ConfirmRoomMessageRemovedDto } from '../models/dto/confirm-room-message-removed.dto';
import { ForwardMessageEvent } from '../models/interfaces/forward-message-event';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ChatsGatewayService {

  private socketStatusSubject = new BehaviorSubject<boolean>(false);
  socketStatus$ = this.socketStatusSubject.asObservable();

  constructor(private readonly socket: Socket) {
    this.listenSocketStatus();
  }

  /* EVENTS */
  isConnected = () => this.socketStatusSubject.value;
  connected = () => this.socket.fromEvent<string>('connected');
  disconnected = () => this.socket.fromEvent<string>('disconnected');

  /* ROOMS MESSAGES */
  roomCreated = () => this.socket.fromEvent<string>('roomCreated');
  createRoom = (room: string) => this.socket.emit('createRoom', room);
  joinRooms = (rooms: string[]) => this.socket.emit('joinRooms', rooms);

  receiveRoomMessageV2 = () =>
    this.socket.fromEvent<RoomMessageDto>('receiveRoomMessageV2');

  sendRoomMessageV2 = (message: RoomMessageDto) =>
    this.socket.emit('sendRoomMessageV2', message);

  confirmRoomMessageVisualized = (message: ConfirmRoomMessageVisualizedDto) =>
    this.socket.emit('confirmRoomMessageVisualized', message);

  receiveRoomMessageVisualized = () =>
    this.socket.fromEvent<ConfirmRoomMessageVisualizedDto>(
      'receiveRoomMessageVisualized'
    );

  confirmRoomMessageRemoved = (message: ConfirmRoomMessageRemovedDto) =>
    this.socket.emit('confirmRoomMessageRemoved', message);

  receiveRoomMessageRemoved = () =>
    this.socket.fromEvent<ConfirmRoomMessageRemovedDto>(
      'receiveRoomMessageRemoved'
    );

  sendForwardMessage = (message: ForwardMessageEvent) =>
    this.socket.emit('forwardRoomMessage', message);

  receiveForwardMessage = () =>
    this.socket.fromEvent<ForwardMessageEvent>('receiveRoomMessageForward');

  /* USERS MESSAGES */
  sendUserMessageV2 = (userMessage: UserMessage) =>
    this.socket.emit('sendUserMessageV2', userMessage);

  receiveUserMessageV2 = () =>
    this.socket.fromEvent<UserMessage>('receiveUserMessageV2');

  joinPrivateRoom = (idUser: string) =>
    this.socket.emit('joinPrivateRoom', idUser);

  confirmUserMessageReceived = (message: ConfirmUserMessageReceivedDto) =>
    this.socket.emit('confirmUserMessageReceived', message);

  receiveUserMessageConfirmed = () =>
    this.socket.fromEvent<ConfirmUserMessageReceivedDto>(
      'receiveUserMessageConfirmed'
    );

  confirmUserMessageVisualized = (message: ConfirmUserMessageVisualizedDto) =>
    this.socket.emit('confirmUserMessageVisualized', message);

  receiveUserMessageVisualized = () =>
    this.socket.fromEvent<ConfirmUserMessageVisualizedDto>(
      'receiveUserMessageVisualized'
    );

  confirmUserMessageRemoved = (message: ConfirmUserMessageRemovedDto) =>
    this.socket.emit('confirmUserMessageRemoved', message);

  receiveUserMessageRemoved = () =>
    this.socket.fromEvent<ConfirmUserMessageRemovedDto>(
      'receiveUserMessageRemoved'
    );

  private listenSocketStatus() {
    this.socket.ioSocket.on('connect', () => {
      console.log(`${ChatsGatewayService.name} Connected`);
      this.socketStatusSubject.next(true);
    });

    this.socket.ioSocket.on('disconnect', () => {
      console.log(`${ChatsGatewayService.name} Disconnected`);
      this.socketStatusSubject.next(false);
    });

    this.socket.ioSocket.on('connect_error', () => {
      console.log(`${ChatsGatewayService.name} Connect Error`);
      this.socketStatusSubject.next(false);
    });
  }
}
